import React from 'react'
import './Trellosidebar.css';

const Workspace = () => {
  return (
    <div>
<p className = 'wrkspcdiv'> Workspace views </p>

    </div>

  )
}

export default Workspace